export enum TestProjectType {
  KS = 'KS',
  GIT = 'GIT',
  CLOUD = 'CLOUD',
}
